var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "amap-box" },
    [
      _vm.search
        ? _c("el-autocomplete", {
            staticStyle: { width: "100%" },
            attrs: {
              "fetch-suggestions": _vm.searchAddres,
              placeholder: "请输入地址搜索"
            },
            on: { select: _vm.handleSelect },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "addr-item" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.value))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "addr" }, [
                          _vm._v(_vm._s(item.name))
                        ])
                      ])
                    ]
                  }
                }
              ],
              null,
              false,
              3213353424
            ),
            model: {
              value: _vm.address,
              callback: function($$v) {
                _vm.address = $$v
              },
              expression: "address"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "amap",
        style: { height: _vm.height },
        attrs: { id: _vm.mapId }
      }),
      _vm._v(" "),
      _vm.naviMapCover
        ? _c("div", {
            staticClass: "cover",
            on: {
              mouseenter: function($event) {
                _vm.naviMapCover = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b016c254", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b016c254","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NaviMap.vue
// module id = 512
// module chunks = 4